<script setup lang="ts">
  import { Chip } from "@ui-kit";
  import { type OrderType } from "@src/api";
  import { default as Section } from "./Section.vue";
  import { default as SectionRow } from "./SectionRow.vue";

  const { type } = defineProps<{ type: OrderType | null }>();
  const emit = defineEmits<{ (e: "change", type: OrderType): void }>();
</script>

<template>
  <Section :title="$t('Тип запроса')">
    <SectionRow data-testid="order-create-type-chip">
      <Chip
        :label="$t('Клиентский')"
        :selected="type === 'pickup'"
        data-testid="order-create-type-chip-pickup"
        @click="emit('change', 'pickup')"
      />
      <Chip
        :label="$t('Коммерческий')"
        :selected="type === 'pickup.commerce'"
        data-testid="order-create-type-chip-commercial"
        @click="emit('change', 'pickup.commerce')"
      />
    </SectionRow>
  </Section>
</template>
